import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdUserImportsImportIdScanEventNames } from "./constants";
import type { GetAppsAppGroupIdUserImportsImportIdScanEventNamesResult } from "./types";
import { isGetAppsAppGroupIdUserImportsImportIdScanEventNamesResult } from "./validators";

export const getAppsAppGroupIdUserImportsImportIdScanEventNames = reactQueryFetcherAdapter(
  appsAppGroupIdUserImportsImportIdScanEventNames,
  (
    signal: AbortSignal,
    appGroupId: string,
    importId: string,
    nameSourceIndex: number,
    excludedSourceIndicesKey: string
  ): Promise<GetAppsAppGroupIdUserImportsImportIdScanEventNamesResult> => {
    if (!Number.isInteger(nameSourceIndex) || nameSourceIndex < 0) {
      return Promise.reject(new Error("scan_event_names requires a non-negative integer name_source_index"));
    }

    const queryParams: Record<string, string> = {
      name_source_index: String(nameSourceIndex),
    };
    if (excludedSourceIndicesKey !== "") {
      queryParams.excluded_source_indices = excludedSourceIndicesKey;
    }

    return fetch<GetAppsAppGroupIdUserImportsImportIdScanEventNamesResult>(
      `/apps/${appGroupId}/user_imports/${importId}/scan_event_names`,
      "GET",
      queryParams,
      { signal }
    );
  },
  isGetAppsAppGroupIdUserImportsImportIdScanEventNamesResult
);
